import {
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaNodeJs,
  FaTrello,
} from "react-icons/fa";
import {
  SiRedux,
  SiNextdotjs,
  SiTypescript,
  SiTailwindcss,
  SiMaterialui,
  SiExpress,
  SiMongodb,
  SiPostgresql,
  SiMysql,
  SiGraphql,
  SiGit,
  SiGithub,
  SiGitlab,
  SiFigma,
  SiJira,
  SiGithubactions,
  SiStoryblok,
} from "react-icons/si";
import zunu from "../images/zunu.png";
import loom from "../images/loom-portfolio.png";
import formBuilder from "../images/formbuilder-portfolio.png";
import quizBuilder from "../images/QuizBuilder.jpg";
import buyAll from "../images/buy-portfolio.png";
import book from "../images/book-portfolio.png";
import kanbanBoard from "../images/kanbanBoard.png";
import youqueristSite from "../images/youquerist-portfolio.png";
import saasjet from "../images/saasjet.jpg";
import goiteens from "../images/goiteens.jfif";
import galich from "../images/galich.png";
import saasjetBusinnes from "../images/saasjet-bussiness.webp";
import saasjetForm from "../images/saasjet-form.webp";

export const Bio = {
  name: "Andrii Solonynka",
  roles: ["Full-stack Developer", "Front-end Developer", "Programmer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Sloian",
  resume:
    "https://drive.google.com/file/d/1gFs9Ec6_ti0zdzH3n5UM3YXpnOUTE-pB/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/andrii-solonynka-1664a4195/",
  twitter: "https://twitter.com/RishavChanda",
  insta: "https://www.instagram.com/rishav_chanda/",
  facebook: "https://www.facebook.com/rishav.chanda.165/",
  email: "andriysolonynka100@gmail.com",
  phone: "+380683548376"
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        icon: FaReact,
        color: "#61DAFB",
      },
      {
        name: "Redux",
        icon: SiRedux,
        color: "#764ABC",
      },
      {
        name: "Next Js",
        icon: SiNextdotjs,
        color: "#ddd",
      },
      {
        name: "HTML",
        icon: FaHtml5,
        color: "#E34F26",
      },
      {
        name: "CSS",
        icon: FaCss3Alt,
        color: "#1572B6",
      },
      {
        name: "JavaScript",
        icon: FaJs,
        color: "#F7DF1E",
      },
      {
        name: "TypeScript",
        icon: SiTypescript,
        color: "#3178C6",
      },
      {
        name: "TailwindCSS",
        icon: SiTailwindcss,
        color: "#06B6D4",
      },
      {
        name: "Storybook",
        icon: SiStoryblok,
        color: "#F97DAB",
      },
      {
        name: "Material UI",
        icon: SiMaterialui,
        color: "#0081CB",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        icon: FaNodeJs,
        color: "#339933",
      },
      {
        name: "Express Js",
        icon: SiExpress,
        color: "#ddd",
      },
      {
        name: "MongoDB",
        icon: SiMongodb,
        color: "#47A248",
      },
      {
        name: "PostgreSQL",
        icon: SiPostgresql,
        color: "#336791",
      },
      {
        name: "MySQL",
        icon: SiMysql,
        color: "#4479A1",
      },
      {
        name: "GraphQL",
        icon: SiGraphql,
        color: "#E10098",
      },
    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "Git",
        icon: SiGit,
        color: "#F05032",
      },
      {
        name: "Github",
        icon: SiGithub,
        color: "#ddd",
      },
      {
        name: "Gitlab",
        icon: SiGitlab,
        color: "#FC6D26",
      },
      {
        name: "Figma",
        icon: SiFigma,
        color: "#F24E1E",
      },
      {
        name: "GitHub Actions",
        icon: SiGithubactions,
        color: "#2088FF",
      },
      {
        name: "Trello",
        icon: FaTrello,
        color: "#0079BF",
      },
      {
        name: "Jira",
        icon: SiJira,
        color: "#0052CC",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: saasjet,
    role: "JavaScript Developer",
    company: "SaasJet",
    date: "February 2022 Till now | Ukraine",
    desc: "As a JavaScript developer, I have extensive experience in developing commercial products for a product-focused company. My work primarily involved creating add-ons, such as developer forms, and Chrome extensions. This role required a deep understanding of JavaScript, HTML, and CSS, as well as familiarity with browser APIs and extension development best practices. My contributions helped enhance the functionality and user experience of the company's products, providing valuable tools for both end-users and developers.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "React.js",
      "Next.js",
      "Atlassian",
      "Forge",
      "Storybook",
      "MaterialUI",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Jira",
    ],
    doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 1,
    img: goiteens,
    role: "Teacher",
    company: "GoIteens",
    date: "November 2022 February 2024 | Ukraine",
    desc: "Teaching programming lessons to children, focusing on HTML, CSS, and JavaScript, allowed me to create a supportive and engaging learning environment. I developed age-appropriate lesson plans that introduced the fundamentals of web development. Throughout my teaching, I prioritized communication and patience, ensuring each student felt comfortable asking questions and expressing their creativity. I employed interactive projects and activities that promoted hands-on learning. My goal was to inspire a love for coding and problem-solving. I also aimed to develop critical thinking and collaboration skills among the students. By adapting my teaching methods to meet individual learning styles, I made programming accessible and enjoyable for all.",
    skills: [
      "Communication",
      "Patience",
      "Creativity",
      "Collaboration",
      "Interactive Learning",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
];

export const education = [
  {
    id: 0,
    img: zunu,
    school: "West Ukrainian National University",
    date: "2022 September - Till now | Ukraine",
    degree: "Cyber Security",
  },
  {
    id: 1,
    img: galich,
    school: "Halytskyi College",
    date: "2018 September - 2022 June | Ukraine",
    degree: "Computer Science",
  },
];

export const projects = [
  {
    id: 1,
    title: "Business Process Manager: Productive Workflow Automation",
    type: "Commercial",
    description:
      "Developed an application to streamline Standard Operating Procedures (SOPs) using No-Code Business Process Management (BPM). The application optimizes Jira workflows with pre-filled fields and dynamic steps, allowing for structured data collection through custom forms, surveys, and quizzes. It enables the scheduling of recurring tasks and pre-assigns issues for immediate starts. Managed pre-built processes with conditional logic, automatically triggering issue transitions after form submission, and setting multiple assignees in Jira for structured collaboration. Provided detailed control over Jira processes through reports, ensuring adherence to procedures and tracking activity via built-in task reports. Delivered a demo version and video tutorial to showcase the application's capabilities and facilitate user onboarding.",
    image: saasjetBusinnes,
    tags: ["TypeScript", "React", "Express.js", "MongoDB", "SaasJet - Form Builder"],
    webapp: "https://marketplace.atlassian.com/apps/1225573/business-process-manager-productive-workflow-automation?hosting=cloud&tab=overview",
  },
  {
    id: 2,
    title: "Smart Jira Forms",
    type: "Commercial",
    description:
      "Developed a solution for automatically converting dynamic forms into actionable tasks within Jira. Designed customizable questionnaires with 16 form and content elements, including options for color and font adjustments to match branding. Implemented conditional logic for dynamic forms based on user input and auto-populated form options with Jira issue field values. Enabled seamless information collection by embedding forms in Confluence, websites, or sharing via external links, and empowered support teams with request-related forms on the Customer Portal. Facilitated issue creation and updates with form values, allowing for new issues to be pre-filled with data, and provided analytics through charts, answer lists, and export options in XLSX/PDF formats.",
    image: saasjetForm,
    tags: ["TypeScript", "React", "Express.js", "MongoDB", "SaasJet - Form Builder"],
    webapp: "https://marketplace.atlassian.com/apps/1227085/smart-jira-forms?tab=overview&hosting=cloud",
  },
  {
    id: 3,
    title: "Book of the Month",
    type: "Commercial",
    description:
      "An e-commerce app for ordering books. One of the largest websites in America where you can browse a catalog of books, choose your selection, make a payment, and confirm receipt.",
    image: book,
    tags: ["TypeScript", "React", "Next.js", "Redux", "Storybook"],
    webapp: "https://bookofthemonth.com",
  },
  {
    id: 4,
    title: "Loom analog",
    type: "Commercial",
    description:
      "Chrome extension Loom analog. An application created for a client based on the requirements of a Loom analog with most of the features of the original Loom.",
    image: loom,
    tags: ["JavaScript", "React", "TypeScript", "React Context", "Chrome Extenstion", "Chrome API"],
    webapp: "",
  },
  {
    id: 5,
    title: "Buy All",
    type: "Commercial",
    description:
      "An e-commerce app for ordering clothing. The app includes user authentication, a complete product list, and the ability to choose, filter, and sort items. Additionally, it offers online chat with a manager and the option for online payment.",
    image: buyAll,
    tags: [
      "TypeScript",
      "React",
      "Next.js",
      "Redux",
      "Node Js",
      "Express Js",
      "MongoDb",
    ],
    webapp: "https://www.buy-all.store",
  },
  {
    id: 6,
    title: "Quiz Builder",
    type: "Personal",
    description:
      "A full‑stack web application for creating custom quizzes. Users can create quizzes with different question types, browse all quizzes, and open a details page for any quiz.",
    image: quizBuilder,
    tags: ["React", "TypeScript", "Vite", "Node Js", "Express Js", "SQLite", "Prisma ORM", "pnpm workspaces"],
    github: "https://github.com/Sloian/quiz-builder",
    webapp: "",
  },
  {
    id: 7,
    title: "Youquerist",
    type: "Commercial",
    description:
      "A marketplace for querists and experts. Anyone can be a querist, meaning a person who can request a service, and an expert who can respond to the querist's proposal, complete the task, and receive monetary compensation. The site includes user authentication, a landing page, a list of all querists and experts, and an admin panel for management.",
    image: youqueristSite,
    tags: ["JavaScript", "React", "Redux", "Node Js", "Express Js", "MongoDb"],
    github: "",
    webapp: "",
  },
  {
    id: 8,
    title: "Form Builder",
    type: "Personal",
    description:
      "A personal website where you can choose form features such as: Text, Paragraph, Dropdown, Select, Divider, Textarea, Date, Checkbox, and includes Google authentication. All these elements are drag and drop. The form can be saved and shared via an open link. Anyone who fills out and submits the form will have their submission visible to the form owner.",
    image: formBuilder,
    tags: [
      "TypeScript",
      "React",
      "TailwindCSS",
      "Shadcn UI",
      "Node Js",
      "Express Js",
      "MongoDb",
      "Google Auth",
    ],
    webapp: "",
  },
  {
    id: 9,
    title: "Kanban Board",
    type: "Personal",
    description:
      "A Kanban Board where you can create, edit, and delete both task columns and tasks themselves. You can also change the positions of columns and tasks. All data is saved in local storage.",
    image: kanbanBoard,
    tags: ["TypeScript", "React", "TailwindCSS", "DND-kit"],
    webapp: "https://kanban-board-xjau.onrender.com",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
